export const partnerConstants = {
	GET_BALANCE_POINTS: 'GET_BALANCE_POINTS',
	POINTS_WAS_LOADED: 'POINTS_WAS_LOADED',
	LOADING_POINTS: 'LOADING_POINTS'
}
